import ApiService from '@/shared/services/api.service';

export const fetchPcuelApplicant = async ({ accountId, organizationId }) => {
    if (!accountId || !organizationId) {
        return null;
    }
    try {
        const { data } = await ApiService.query('/building-permit/applicant', {
            params: { accountId, organizationId },
        });
        return data;
    } catch (error) {
        console.error('[PCUEL applicant] fetch failed', error?.response?.status || error?.message);
        return null;
    }
};

export default { fetchPcuelApplicant };
